// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-7c78693f]{line-height:1.5}.agreement h1[data-v-7c78693f]{font-size:28px;margin-block:8px;font-weight:700}.agreement h2[data-v-7c78693f]{font-size:24px;margin-block:12px 8px;font-weight:500;text-align:center}.agreement p[data-v-7c78693f]{margin-block:0 12px}.agreement a[data-v-7c78693f]{color:var(--color-primary);font-weight:500}", ""]);
// Exports
module.exports = exports;
